import { create } from "zustand";
import { GameCard } from "modules/cards/model/card";
import { TradeCard } from "modules/swap-calculator/model/tradeCard";

interface AddCardModalState {
  open: boolean;
  card: GameCard | TradeCard | null;
}

interface AddCardModalStore {
  // Modal state
  modal: AddCardModalState;

  // Modal actions
  openModal: (card: GameCard | TradeCard) => void;
  closeModal: () => void;
  reset: () => void;
}

const DEFAULT_MODAL_STATE: AddCardModalState = {
  open: false,
  card: null,
};

export const useAddCardModalStore = create<AddCardModalStore>((set) => ({
  // Initial state
  modal: DEFAULT_MODAL_STATE,

  // Modal actions
  openModal: (card) =>
    set({
      modal: {
        open: true,
        card,
      },
    }),

  closeModal: () =>
    set({
      modal: DEFAULT_MODAL_STATE,
    }),

  // Reset all
  reset: () =>
    set({
      modal: DEFAULT_MODAL_STATE,
    }),
}));

/**
 * Hook for add card modal state and actions
 */
export const useAddCardModal = () => {
  const modal = useAddCardModalStore((state) => state.modal);
  const openModal = useAddCardModalStore((state) => state.openModal);
  const closeModal = useAddCardModalStore((state) => state.closeModal);

  return { modal, openModal, closeModal };
};
